module.exports = __webpack_public_path__ + "static/img/ikonaMuzyka-OFF.cbc68da6.png";